var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"s-card-hover",staticStyle:{"padding":"15px","position":"relative"}},[_c('div',{staticClass:"s-card-simple-info",style:({color: _vm.color})},[_vm._t("default")],2),_vm._v(" "),_vm._t("extra"),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px","margin-top":"15px"}},[_vm._v(_vm._s(_vm.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }